<template>
  <div>
    <div class="info" v-if="!edit && !mover && !typer">
      <controls
        v-if="canEdit"
        :question="question"
        @edit="showEdit"
        @remove="remove"
        @mover="showMove"
        @typer="showTyper"
      ></controls>

      <h4 class="question-title">
        <span v-if="question.required">*</span>
        {{ question.title }}
      </h4>

      <div class="question-body">
        <div class="question-field">
          <span v-html="question.fields[0].choice"></span>
        </div>
      </div>
    </div>

    <div class="edit" v-if="edit && !mover && !typer">
      <form @submit.prevent="onSubmit">
        <div class="field">
          <label class="label">Title</label>
          <div class="control has-icons-right mt-2">
            <input
              type="text"
              :class="['input', { 'is-danger': errors['title'] }]"
              v-model="data['title']"
              name="title"
              required
            />
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field" v-for="(field, index) in data.fields" :key="index">
          <label class="label">Instruction</label>
          <div class="columns">
            <div class="column">
              <div class="control field-options">
                <quill-editor
                  :class="[{ 'is-danger': errors[`choice${index}`] }]"
                  v-model="field['choice']"
                  :options="choiceEditorOptions"
                  required
                ></quill-editor>
                <span
                  class="icon is-small is-right"
                  v-if="errors[`choice${index}`]"
                  ><i class="fa fa-warning"></i
                ></span>
              </div>
              <p v-if="errors[`choice${index}`]" class="help is-danger">
                {{ errors[`choice${index}`] }}
              </p>
            </div>
          </div>
        </div>

        <div class="question-meta">
          <div class="field">
            <label class="label">Require to Agree</label>
            <div class="control mt-2 select is-fullwidth">
              <select
                name="required"
                v-model="data['required']"
                :disabled="question.interviewMandatory"
              >
                <option
                  v-for="opt in yesNo"
                  :value="opt.value"
                  :key="opt.value"
                >
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="field">
            <label class="label">Agreement Checkbox Text</label>
            <div class="control mt-2 is-fullwidth">
              <input
                type="text"
                :class="['input']"
                v-model="data.meta.customAgreementText"
                placeholder="Agree"
                name="ctaText"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Agreement Input Label</label>
            <div class="control mt-2 is-fullwidth">
              <input
                type="text"
                :class="['input']"
                v-model="data.meta.customAgreementInputLabel"
                placeholder="Enter First And Last Name"
                name="ctaText"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Include Signature Box</label>
            <div class="control mt-2 select is-fullwidth">
              <select
                name="hideNextButton"
                v-model="data.meta.includeSignatureBox"
              >
                <option
                  v-for="opt in yesNo"
                  :value="opt.value"
                  :key="opt.value"
                >
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="field">
            <label class="label">Hide Next Button</label>
            <div class="control mt-2 select is-fullwidth">
              <select name="hideNextButton" v-model="data.meta.hideNextButton">
                <option
                  v-for="opt in yesNo"
                  :value="opt.value"
                  :key="opt.value"
                >
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="field">
            <label class="label">Call To Action</label>
            <div class="columns">
              <div class="column is-3">
                <label class="label">Show CTA</label>
                <div class="select">
                  <select name="ctaShow" v-model="data.meta.ctaShow">
                    <option
                      v-for="opt in yesNo"
                      :value="opt.value"
                      :key="opt.value"
                    >
                      {{ opt.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="column is-3 field-options">
                <label class="label">CTA Text</label>
                <div class="control field-options">
                  <input
                    type="text"
                    :class="['input']"
                    v-model="data.meta.ctaText"
                    name="ctaText"
                  />
                </div>
              </div>
              <div class="column is-3 field-options">
                <label class="label">CTA URL</label>
                <div class="control field-options">
                  <input
                    type="text"
                    :class="['input']"
                    v-model="data.meta.ctaUrl"
                    name="ctaUrl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-grouped mt2 has-text-right">
          <div class="control">
            <button
              :class="['button', 'is-primary', { 'is-loading': loading }]"
            >
              Update
            </button>
            <button
              type="button is-link"
              class="button"
              v-on:click="hideEdit()"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>

    <question-move
      v-if="mover"
      :question="question"
      @hide="hideMove"
    ></question-move>
    <question-type
      v-if="typer"
      :question="question"
      @hide="hideTyper"
    ></question-type>
  </div>
</template>

<script>
import Vue from "vue";
import baseQuestion from "./baseQuestion";
import RoutingRules from "../routing_rules/RoutingRules";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "single-text",

  mixins: [baseQuestion],

  components: { quillEditor },

  data() {
    return {
      choiceEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"]
          ],
          htmlEditButton: {}
        },
        theme: "snow",
        placeholder: "Instructions..."
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
